<template>
  <div class="flexd">
    <div class="leftList">
      <div>订单类别</div>
      <div
        v-for="(item, index) in list1"
        :key="index"
        :class="{ reds: index + 1 == currentIndex }"
        style="cursor: pointer"
        @click="clickIndex(item, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="layout-content" style="background: transparent; margin: 0px">
      <!-- <div v-if="list.length"> -->
      <div v-if="list.length">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          stripe
          style="width: 100%"
          :header-cell-style="{ 'background-color': '#f8f8f9' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="名称" show-overflow-tooltip width="200">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column
            label="报名类别"
            width="200"
            v-if="currentName == '展位'"
          >
            <template slot-scope="scope"
              ><span style="margin-right: 5px">
                {{ scope.row.reportType }}
                <span>
                  <span
                    v-for="(item, index) in scope.row.bindAreas"
                    v-if="item.isEnable"
                    :key="index"
                    >{{ item.name }}</span
                  >
                </span> </span
              ><span
                class="lookClass"
                style="cursor: pointer"
                @click="detailNumbers(scope.row)"
                >{{ scope.row.reportType ? "修改" : "设置" }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            label="商品分组"
            width="130"
            v-if="currentName !== '展位'"
          >
            <template slot-scope="scope"
              ><span style="margin-right: 5px"> {{ scope.row.groupType }} </span
              ><span
                class="lookClass"
                style="cursor: pointer"
                @click="detailNumbers(scope.row)"
                >{{ scope.row.groupType ? "修改" : "设置" }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="shortName"
            label="单价"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">{{
              "【" +
              scope.row.currencyKind +
              "】" +
              scope.row.price +
              (scope.row.unit ? "/" + scope.row.unit : "")
            }}</template>
          </el-table-column>
          <el-table-column prop="minBuy" label="起订数量" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="total" label="总数量" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="specs" label="规格" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="boothKind"
            label="展位类型"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="boothArea"
            label="展位面积"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.boothArea ? scope.row.boothArea + "㎡" : ""
            }}</template>
          </el-table-column>
          <el-table-column
            prop="displayOrder"
            label="显示顺序"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="是否启用" show-overflow-tooltip>
            <template slot-scope="scope"
              ><el-switch
                v-model="scope.row.isEnable"
                active-color="#d13119"
                inactive-color="#dcdfe6"
                @change="(status) => setAudit(scope.row, status)"
              >
              </el-switch
            ></template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 20px">
          <el-button
            @click="batch()"
            style="background-color: #d13119; color: #fff"
            >{{
              currentName == "展位" ? "批量设置报名类别" : "批量设置分组"
            }}</el-button
          >
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <el-dialog
      title="设置报名类别"
      :visible.sync="rejectModel"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="商品名称" prop="name">
          <el-input
            type="text"
            size="small"
            v-model="ruleForm.name"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="类别" prop="radio" v-if="currentName == '展位'">
          <el-radio v-model="ruleForm.radio" label="1">直销</el-radio>
          <!-- <el-radio v-model="ruleForm.radio" label="2">展团 </el-radio> -->
        </el-form-item>
        <el-form-item
          label="展区"
          prop="region"
          v-if="ruleForm.radio == 1 && currentName == '展位'"
        >
          <el-select
            v-model="ruleForm.region"
            multiple
            placeholder="请选择展区"
          >
            <el-option
              v-for="item in list2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="展团"
          prop="region"
          v-if="ruleForm.radio == 2 && currentName == '展位'"
        >
          <el-select
            v-model="ruleForm.region"
            multiple
            placeholder="请选择展区"
          >
            <el-option
              v-for="item in list2"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商品分组"
          prop="region"
          v-if="currentName !== '展位'"
        >
          <el-select v-model="ruleForm.region" placeholder="请选择商品分组">
            <el-option
              v-for="item in list4"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject('ruleForm')"
          >确定</Button
        >
        <Button @click="rejectModel = false" style="margin-left: 10px"
          >取消</Button
        >
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "areaPage",
  data() {
    return {
      list: [],
      list1: [],
      list2: [],
      list4: [],
      currentIndex: 1,
      currentId: "",
      currentName: "展位",
      rejectModel: false,
      rejectModel1: false,
      rejectModel2: false,
      id: "",
      selectId: [],
      ruleForm: {
        radio: "",
        name: "",
        region: [],
      },
      listType: ["展位", "广告", "会议", "租凭"],
      rules: {
        name: [{ required: true, message: "商品名称" }],
        radio: [{ required: true, message: "请选择类别", trigger: "change" }],
        region: [{ required: true, message: "请选择内容", trigger: "change" }],
      },
    };
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionInfo: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
      exhibitionId: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    document.title = "商品管理";
    this.init1();
  },
  methods: {
    ...mapActions({
      getExhibitionCommodity: "hostManage/getExhibitionCommodity",
      getExhibitionCommodityKind: "hostManage/getExhibitionCommodityKind",
      getCommodities: "hostManage/getCommodities",
      areaIsEnable: "hostManage/areaIsEnable",
      getAllArea: "hostManage/getAllArea1",
      batchSettleReportType: "hostManage/batchSettleReportType",
      getExhibitionCommodityGroup: "hostManage/getExhibitionCommodityGroup",
      commodityIsEnable: "hostManage/commodityIsEnable",
      batchSettleGroup: "hostManage/batchSettleGroup",
    }),
    // 转换日期格式
    async init() {
      let opt = {
        exhibitionId: this.exhibitionId.id,
      };
      let proData = await this.getExhibitionCommodity(opt);
      this.init1();
    },
    async init1() {
      let opt = {
        exhibitionId: this.exhibitionId.id,
      };

      let proData2 = await this.getExhibitionCommodityKind(opt);
      let proData3 = await this.getAllArea(opt);
      let proData4 = await this.getExhibitionCommodityGroup(opt);
      this.list1 = proData2;
      this.list1 = proData2;
      this.list2 = proData3;
      let array = proData4.filter((e) => {
        return e.isEnable;
      });
      this.list4 = array;
      if (proData2) {
        this.lists(this.list1[0].id);
        this.currentId = this.list1[0].id;
      }
    },
    async lists(id) {
      let opt1 = {
        exhibitionId: this.exhibitionId.id,
        kindId: id,
      };
      let proData1 = await this.getCommodities(opt1);
      this.list = proData1;
    },
    handleSelectionChange(value) {
      console.log(value);
      let name = [];
      this.selectId = [];
      value.forEach((e) => {
        this.selectId.push(e.id);
        name.push(e.name);
        this.ruleForm.name = name.toString();
      });
    },
    batch() {
      if (this.selectId.length == 0) {
        this.$message.error("请先选择修改项！");
        return;
      }
      this.ruleForm.region = [];
      this.rejectModel = true;
    },
    // 修改订单数
    detailNumbers(item) {
      this.id = item.id;
      this.ruleForm.name = item.name;
      this.selectId = [];
      this.selectId.push(item.id);
      if (!item.languageType) {
        this.ruleForm.radio = "1";
      } else {
        item.languageType == "直销"
          ? (this.ruleForm.radio = "1")
          : (this.ruleForm.radio = "2");
      }
      this.ruleForm.region = [];
      if (this.currentName !== "展位") {
        console.log(item);
        if (item.exhibitionCommodityGroupId) {
          this.ruleForm.region = item.exhibitionCommodityGroupId;
        } else {
          this.ruleForm.region = "";
        }
      } else {
        let array = [];
        if (item.bindAreas.length > 0) {
          item.bindAreas.forEach((e) => {
            if (e.isEnable) {
              this.ruleForm.region.push(e.id);
            }
          });
        }
      }
      console.log(this.ruleForm.region, 111);
      this.rejectModel = true;
    },

    async setAudit(item, status) {
      let res = await this.commodityIsEnable({
        id: item.id,
        isEnable: status,
      });
      if (res && res.successed) {
        this.$Message.success("设置成功");
        this.rejectModel = false;
      }
      this.lists(this.currentId);
    },
    async handleSubmitReject(formName) {
      let valid = await this.validForm(formName);
      if (!valid) return;

      if (this.currentName !== "展位") {
        const res = await this.batchSettleGroup({
          commodityIds: this.selectId,
          exhibitionCommodityGroupId: this.ruleForm.region.toString(),
        });
        if (res && res.successed) {
          this.$Message.success("设置成功");
          this.rejectModel = false;
        }
      } else {
        let array = Array.from(new Set(this.ruleForm.region));
        const res = await this.batchSettleReportType({
          commodityIds: this.selectId,
          type: this.ruleForm.radio == 1 ? "直销" : "展团 ",
          bindIds: array,
        });
        if (res && res.successed) {
          this.$Message.success("设置成功");
          this.rejectModel = false;
        }
      }

      this.lists(this.currentId);
    },
    handleClose() {
      this.rejectModel = false;
      this.$refs["ruleForm"].resetFields();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    clickIndex(item, index) {
      this.currentName = item.name;
      this.lists(item.id);
      this.currentId = item.id;
      this.currentIndex = index + 1;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
  },
};
</script>
  
<style scoped lang="scss">
.reds {
  color: #d13119 !important;
}
.required {
  color: red;
  margin-right: 4px;
}
.header-tabs {
  // display: flex;

  position: relative;
}
.searchPro {
  position: absolute;
  right: 24px;
  top: 0;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}
.ivu-table-wrapper {
  // padding-bottom: 20px!important;
  overflow: visible !important;
}
.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #d13119;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #d13119 !important;
  border-color: #d13119 !important;
}

.flexd {
  display: flex;
}
.leftList {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
  div {
    padding-left: 15px;
    line-height: 47px;
    border-bottom: 1px solid #dcdfe6;
    color: #000;
  }
}
.layout-content {
  flex: 1;
}
::v-deep .el-select {
  width: 100%;
}
</style>
  